import ColumnsFilterButtonTable from '../../../ColumnsFilterButtonTable'
import PaginationSizeChooser from '../TableActions/components/PageSizeChooser'
import ShowActiveNameFilter from '../TableActions/components/ShowActiveNameFilter'
import TabularButton from '../TableActions/components/TabularButton'

const TABLE_ACTIONS_TYPE = {
  CUSTOM: 'CUSTOM',
  PLATFORM_COMPONENTS: 'PLATFORM_COMPONENTS',
  DEFAULT: 'DEFAULT',
  DROPDOWN: 'DROPDOWN'
}

const TABLE_ACTION_COMPONENTS = {
  ColumnsFilterButtonTable: ColumnsFilterButtonTable,
  PaginationSizeChooser: PaginationSizeChooser,
  ShowActiveNameFilter: ShowActiveNameFilter,
  TabularButton: TabularButton
}

export { TABLE_ACTIONS_TYPE, TABLE_ACTION_COMPONENTS }
